import { Flex, type FlexProps } from '@vesyl/ui/chakra'
import {
  PlatformLogo as PlatformLogoSvg,
  type PlatformLogoProps as SvgLogoProps,
} from '@vesyl/ui/vesyl/logo-platform'
import { LuReceiptText } from 'react-icons/lu'

type PlatformLogoProps = SvgLogoProps & {
  platform?: string | null
}

// Supported platforms
const platforms = [
  'shopify',
  'amazon',
  'amazon2',
  'woocommerce',
  'etsy',
  'ebay',
  'ebay2',
  'exigo',
  'shipstation',
]

export const PlatformLogo = (props: PlatformLogoProps) => {
  const { platform, ...rest } = props

  if (!platform) return null

  if (platform === 'custom' || platform === 'manual')
    return (
      <Flex w="6" alignItems="center" justifyContent="center" {...(rest as FlexProps)}>
        <LuReceiptText size={16} />
      </Flex>
    )

  if (!platforms.includes(platform)) return null

  return <PlatformLogoSvg platform={platform} w="6" {...rest} />
}
